import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export { useHomepageStyles };

const useHomepageStyles = makeStyles((theme: Theme) =>
	createStyles({
		homePage: {
			display: "flex",
		},
		sidebar: {
			display: "flex",
			flexDirection: "column",
			height: "100vh",
			width: "250px",
			zIndex: 1,
			flexShrink: 0,
			whiteSpace: "nowrap",
			borderRight: "#dddddd solid 1px",
		},
		sidebarOpen: {
			width: "250px",
			overflowX: "hidden",
			transition: theme.transitions.create("width", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen,
			}),
		},
		sidebarClose: {
			transition: theme.transitions.create("width", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			overflowX: "hidden",
			width: theme.spacing(9),
		},
		logoContainer: {
			display: "flex",
			height: 80,
		},
		logoImage: {
			maxHeight: 50,
			margin: "auto",
		},
		emptyText: {
			height: "50%",
			textAlign: "center",
			transform: "translateY(100%)",
		},
		iframe: {
			width: "100%",
			height: "100%",
			border: 0,
		},
		iframeContainer: {
			flexGrow: 1,
			// width: "100vw",
		},
		drawerButton: {
			padding: 10,
			margin: 5,
			marginTop: 0,
		},
		line: {
			borderTop: `1px solid ${theme.palette.primary.main}`,
			position: "relative",
			padding: 2,
		},
		collapseIcon: {
			transform: "rotate(-180deg)",
		},
		collapsedIcon: {
			paddingTop: 2,
		},
		collapseText: {
			paddingTop: "1px",
			paddingLeft: "5px",
		},
	})
);
